(function ($) {
    let $fn = $(".comp_welcome");

    if ($fn.length) {
        let $form = $fn.find(".wrp_form");
        $form.stick_in_parent({
            offset_top: 300
        })
    }
})(jQuery);